import React from 'react';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';
import { TextButton } from '@wix/design-system';
import githubImage from '../../../../assets/images/github.png';
import vercelImage from '../../../../assets/images/vercel.png';
import netlifyImage from '../../../../assets/images/netlify.png';
import { DeploymentHostType } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import { DEPLOY_APP_VENDOR_SITE } from '../../../../constants/routes';
import type { DeploymentHostTypeConfig } from './types';

export const useDeploymentOptions = (): Record<
  DeploymentHostType,
  DeploymentHostTypeConfig
> => {
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();
  const { reportClickOnGithubLink } = useTemplatesPageBi();

  return {
    [DeploymentHostType.NETLIFY]: {
      id: DeploymentHostType.NETLIFY,
      title: t('app.template-page.modal.self-hosted.step1.netlify'),
      subtitle: (
        <Trans i18nKey="app.template-page.modal.self-hosted.step1.netlify.desc">
          <TextButton
            size="small"
            onClick={() => {
              return window.open(
                DEPLOY_APP_VENDOR_SITE[DeploymentHostType.NETLIFY],
              );
            }}
          />
        </Trans>
      ),
      image: netlifyImage,
    },
    [DeploymentHostType.VERCEL]: {
      id: DeploymentHostType.VERCEL,
      title: t('app.template-page.modal.self-hosted.step1.vercel'),
      subtitle: (
        <Trans i18nKey="app.template-page.modal.self-hosted.step1.vercel.desc">
          <TextButton
            size="small"
            onClick={() => {
              return window.open(
                DEPLOY_APP_VENDOR_SITE[DeploymentHostType.VERCEL],
              );
            }}
          />
        </Trans>
      ),
      image: vercelImage,
    },
    [DeploymentHostType.UNKNOWN_DEPLOYMENT_HOST_TYPE]: {
      id: DeploymentHostType.UNKNOWN_DEPLOYMENT_HOST_TYPE,
      title: t('app.template-page.modal.self-hosted.step1.github'),
      subtitle: (
        <Trans i18nKey="app.template-page.modal.self-hosted.step1.github.desc">
          <TextButton
            size="small"
            dataHook="deploy-elsewhere-github-link"
            onClick={() => {
              reportClickOnGithubLink(template.id);
              return window.open(template?.repositoryUrl || '');
            }}
          />
        </Trans>
      ),
      image: githubImage,
    },
  };
};
